import client from "api/client";


const _client = client.route("/log");

const log = {
	app: (payload) => _client.post("/app", payload)
};

export default log;